baseApp.service('DateRangeService', ['$rootScope', '$filter', '$state', 'TimeZoneService', function ($rootScope, $filter, $state, TimeZoneService) {
	var MAX_HISTORY = 10;
	var JUMP_MOD = 0.9;
	var dateRangeHistory = [];
	var tempDate = new Date();
	var HOUR = (moment(tempDate).unix() - moment(tempDate).subtract('1', 'hours').unix()) * 1000;
	var DAY = ((moment(tempDate).unix() - moment(tempDate).subtract('2', 'days').unix()) * 1000) - 1;
	var WEEK = ((moment(tempDate).unix() - moment(tempDate).subtract('8', 'days').unix()) * 1000) - 1;
	var MONTH = ((moment(tempDate).unix() - moment(tempDate).subtract('31', 'days').unix()) * 1000) - 1;

	var dateRangeService = {
		currentDateRangeRequested: {}, //  to be used by components to store date ranges of original requests (to keep across state changes)
		updateBucketDuration: null,
		getCopyOfCurrentDateRange: function(numOfBuckets) {
			return {
				from: new Date(currentDateRange.from),
				to: new Date(currentDateRange.to),
				bucketDuration: (numOfBuckets && Math.trunc((currentDateRange.to - currentDateRange.from) / numOfBuckets)) || currentDateRange.bucketDuration
			}
		},
		getNewRange: function(from, to, bucketDuration) {
			return {
				from: from || null,
				to: to || null,
				bucketDuration: bucketDuration || null,
			};
		},
		initCurrent: function(from, to, bucketDuration) {
			currentDateRange = dateRangeService.getNewRange(from, to, bucketDuration);
		},
		initCurrentFromDateRange: function(dateRange) {
			currentDateRange = dateRangeService.getNewRange(dateRange.from, dateRange.to, dateRange.bucketDuration);
		},
		initDateRange: function(dateRange) {
			dateRange.from = new Date(currentDateRange.from);
			dateRange.to = new Date(currentDateRange.to);
		},
		// from, to and bucket duration of inner zoom (not by datepicker) all in milis
		// returns if the dates were updates. if the dates are updated, the rootscope dates will change which will cause a state change
		zoomTo: function (from, to, bucketDuration, noHistory, extraParams) {
			from = from || currentDateRange.from;
			to = to || currentDateRange.to;
			bucketDuration = bucketDuration || currentDateRange.bucketDuration;

			var updateDates = false;

			if (!this.sameRange(from, to)) {
				if (!noHistory) {
					dateRangeHistory.push(this.getNewRange(currentDateRange.from, currentDateRange.to, currentDateRange.bucketDuration));
					if (dateRangeHistory.length > MAX_HISTORY) {
						dateRangeHistory = dateRangeHistory.slice(1);
					}
				}
				updateDates = true;
			}

			if (bucketDuration && currentDateRange.bucketDuration !== bucketDuration) {
				currentDateRange.bucketDuration = bucketDuration;
			}

			if (updateDates) {
				if (from !== currentDateRange.from || to !== currentDateRange.to) {
					var defaultTime = this.getEndOfDay();
					$state.go($state.current.name, angular.extend({
						start: from,
						end: to === defaultTime && defaultTime.getTime() ? null : to,
					}, extraParams || {}), {location: 'replace'});
				}

			} else if (bucketDuration) { // no date range update, but maybe we should update the bucket duration (used atm for display near daterangepicker)
				if (typeof  this.updateBucketDuration == 'function') {
					this.updateBucketDuration(bucketDuration);
				}
			}

			return updateDates;
		},
		zoomToDateRange: function(newDateRange, noHistory, extraParams) {
			this.zoomTo(newDateRange.from, newDateRange.to, newDateRange.bucketDuration, noHistory, extraParams);
		},
		sameRange: function (from, to) {
			return currentDateRange.from == from  && currentDateRange.to == to;
		},
		goBack: function () {
			this.go(-1);
		},
		goForward: function () {
			this.go(1);
		},
		go: function(mod) {
			var newDateRange = this.getNewRange(currentDateRange.from, currentDateRange.to, currentDateRange.bucketDuration);
			var jumpLength = (newDateRange.to - newDateRange.from) * JUMP_MOD * mod;
			newDateRange.from = Math.floor(newDateRange.from + jumpLength);
			newDateRange.to = Math.floor(newDateRange.to + jumpLength);

			this.zoomToDateRange(newDateRange);
		},
		goHistory: function () {
			this.zoomToDateRange(dateRangeHistory.pop(), true);
		},
		hasHistory: function () {
			return dateRangeHistory.length > 0;
		},
		getDateText: function(startDateMili, endDateMili) {
			var now = moment();

			let rangeText = this.getRangeTextFromParams(startDateMili, endDateMili);
			if (rangeText) {
				return rangeText;
			}

            var start = moment(startDateMili);
            var end = moment(endDateMili);

			if (now.isSame(end, 'day')) {
			    var duration = end.diff(start);
				if (now.isSame(end, 'minute') && duration === HOUR) {
					return 'Last Hour';
				}
				if (duration === DAY) {
					return 'Last Day';
				}
				if (duration === WEEK) {
					return 'Last 7 Days';
				}
				if (duration === MONTH) {
					return 'Last 30 Days';
				}
			}

			if (endDateMili < startDateMili) {
				return 'Realtime';
			}

			if (!moment(end).add(2, 'ms').isSame(end, 'day')) {
				endDateMili = endDateMili + 1;
			}

			var startText, endText;
			if  (start.hour() === 0 && start.minute() === 0) {
				startText = $filter('date')(startDateMili, 'mediumDate');
			} else {
				startText = $filter('date')(startDateMili, 'medium');
			}

			if  (end.hour() === 23) {
				endText = $filter('date')(endDateMili, 'mediumDate')
			} else {
				endText = $filter('date')(endDateMili, 'medium')
			}

			return startText + ' - ' + endText;
		},

		getRangeFromText: function(rangeText) {
			if (rangeText === 'Last Hour') {
				return '-1h';
			}
			if (rangeText === 'Last Day') {
				return '-1d';
			}
			if (rangeText === 'Last 7 Days') {
				return '-7d';
			}
			if (rangeText === 'Last 30 Days') {
				return '-30d';
			}
			return null;
		},

		getRangeTextFromParams: function(start, end) {
			if (typeof start !== 'string') return null;
			let [num, unit] = this.parseRangeTextStart(start);
			if (end === "now" && num !== null && unit !== null) {
				return 'Last ' + ((num > 1) ? num + ' ' : '') + unit.charAt(0).toUpperCase() + unit.slice(1) + ((num > 1) ? 's' : '');
			}
			return null;
		},

		parseRangeTextStart: function(start) {
			if (typeof start !== 'string') return [null, null];
			if (start.match(/-\d+[d,h]/) !== null) {
				let num = start.match(/\d+/)[0];
				let char = start.match(/[d,h]/)[0];
				let unit = '' + ((char === 'd') ? 'day' : 'hour');
				return [num, unit];
			}
			return [null, null];
		},

		hasJumpForward: function() {
			var nextToTime = currentDateRange.to + ((currentDateRange.to - currentDateRange.from) * JUMP_MOD);
			return (nextToTime <= this.getEndOfDay().getTime() + 10 && nextToTime >= this.getEndOfDay().getTime() - 10) || nextToTime < new Date().getTime();
		},
		getEndOfDay: function() {
			var defaultTime = new Date();
			defaultTime.setHours(23);
			defaultTime.setMinutes(59);
			defaultTime.setSeconds(59);
			defaultTime.setMilliseconds(999);
			return defaultTime;
		},
	};

	var currentDateRange = {};

	return dateRangeService;
}]);